export default __webpack_public_path__ + "static/media/uv44_kr_rudl_a2.5f3aa35b.mp3";